import { createSelector } from 'reselect';
import { AppState } from '$/store';
import * as Bixby from '$/core';

const getIsCurrentCompanyPublic = ({ releaseFeatureFlagsState, companyState }: AppState) => {
  return !!(
    releaseFeatureFlagsState &&
    companyState &&
    companyState.currentCompany &&
    !Bixby.Utils.isNullOrEmpty(companyState.currentCompany) &&
    companyState.currentCompany.isSECPublic &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagPublicCompanies && _.isEnabled
    )
  );
};

export const getIsCurrentCompanyPublicState = createSelector(
  [getIsCurrentCompanyPublic],
  (isCurrentCompanyPublic: boolean) => ({ isCurrentCompanyPublic })
);

const getAllPrivateAdminCompanies = ({ companyState }: AppState) => {
  const { companies } = companyState;
  if (!companies) return companies;

  return companies.filter(_ => !_.isSECPublic);
};

export const getAllPrivateAdminCompaniesState = createSelector(
  [getAllPrivateAdminCompanies],
  (companies: Bixby.Models.AdminCompanySlim[] | undefined) => ({ companies })
);

const getAllPublicAdminCompanies = ({ companyState }: AppState) => {
  const { companies } = companyState;
  if (!companies) return companies;

  return companies.filter(_ => _.isSECPublic);
};

export const getAllPublicAdminCompaniesState = createSelector(
  [getAllPublicAdminCompanies],
  (companies: Bixby.Models.AdminCompanySlim[] | undefined) => ({ companies })
);
